import React from 'react';
import { oneOf, string } from 'prop-types';
import { cx } from '@emotion/css';

import { loader } from '../style';

/**
 * Loader using CSS animation
 * @param {string} width - width of loader
 * @param {string} height - height of loader
 * @returns
 */
const LoaderAnimate = (props) => {
  const { className, size, variant } = props;

  return <div className={cx(loader({ size, variant }), className)} />;
};

LoaderAnimate.propTypes = {
  className: string,
  size: string,
  variant: oneOf(['primary', 'white']),
};

LoaderAnimate.defaultProps = {
  className: '',
  size: '',
  variant: 'primary',
};

export default LoaderAnimate;
